// extracted by mini-css-extract-plugin
export var explainable = "_bg-a";
export var printerCard = "_bg-1";
export var printerCardConfigured = "_bg-2";
export var printerCardError = "_bg-3";
export var printerCardsContainer = "_bg-0";
export var printerIcon = "_bg-8";
export var printerIconConfigured = "_bg-5";
export var printerIconContainer = "_bg-4";
export var printerIconError = "_bg-6";
export var printerIconUnconfigured = "_bg-7";
export var workstationsTableCard = "_bg-9";